<template>
  <div id="pass21">
    <v-form ref="sR1Form" v-model="sR1FormValid" lazy-validation>
      <v-row id="pass1R">
        <v-col cols="12">
          <v-card class="ep-rechner-box">
            <v-col cols="12" class="p-0">
              <div class="v-card__title p-0">
                <h2 class="v-card--head--title">
                  {{
                    formatDBText(selectedLang.AdditionalTrainTile1, {
                      bookingCode: dataTrain.bookingCode,
                    })
                  }}
                </h2>
              </div>
            </v-col>
            <v-card-text>
              <v-row v-if="rideCheck > 1">
                <v-col cols="12">
                  <div class="v-card--msg">
                    <h2 class="ep-rechner-h2 pb-0">
                      {{ selectedLang.AdditionalTrainTile2 }}
                    </h2>
                  </div>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-chip-group :mandatory="mandaNOR" v-model="nOfRidesSelected" active-class="primary"
                    :disabled="pass21">
                    <v-chip large label class="ma-2" v-for="part in kiOfRides" :key="part.text">
                      <span v-html="part.text"></span>
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
              <v-row v-if="this.dataTrain.nOPa > 1">
                <v-col cols="12">
                  <div class="v-card--msg">
                    <h2 class="ep-rechner-h2 pb-0">
                      {{ additionalTrainTile7 }}
                    </h2>
                  </div>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-chip-group :mandatory="mandaNOP" v-model="nOP" :disabled="pass21" active-class="primary">
                    <v-chip large label class="ma-2" v-for="pass in kiOfPas" :key="pass.text">
                      {{ pass.text }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row v-if="selectedDiv == '21'">
                <v-col cols="12">
                  <v-btn v-if="!pass1R" id="confirm-data-fl" block @click="confirmJournes()"
                    :disabled="pass21 || !go4ward" class="btn-ep-next-step">
                    {{ selectedLang.AdditionalTrainTile14 }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="selectedDiv != '21' && !noChange">
                <v-col cols="12">
                  <v-btn v-if="pass21 && !noChange" block class="btn-ep-back-to" @click="backToSpecificTile('21')">{{
                    selectedLang.AdditionalTrainTile15 }}</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
export default {
  name: "AdditionalRidesTile",
  data: function () {
    return {
      rideCheck: this.$store.state.dataTrain.nOfRides,
      nOfRidesSelected: null,
      nOP: 0,
      mandaNOR: false,
      mandaNOp: false,
      go4ward: false,
      kiOfRides: [
        {
          text: this.formatDBText(
            this.$store.state.selectedLang.AdditionalTrainTile3,
            { destination: this.$store.state.dataTrain.destination }
          ),
          valN: 1,
        },
        {
          text: this.formatDBText(
            this.$store.state.selectedLang.AdditionalTrainTile4,
            { start: this.$store.state.dataTrain.start }
          ),
          valN: 2,
        },
        {
          text: this.$store.state.selectedLang.AdditionalTrainTile5,
          valN: 3,
        },
      ],
      kiOfPas: [
        {
          text: this.$store.state.selectedLang.AdditionalTrainTile8,
          valN: 1,
        },
        {
          text: this.$store.state.selectedLang.AdditionalTrainTile9,
          valN: 2,
        },
        {
          text: this.formatDBText(
            this.$store.state.selectedLang.AdditionalTrainTile10,
            { nOPa: this.$store.state.dataTrain.nOPa }
          ),
          valN: 3,
        },
      ],
      additionalTrainTile7: this.$store.state.selectedLang.AdditionalTrainTile7,
    };
  },
  computed: {
    ...mapState(["selectedLang", "selectedDiv", "dataTrain", "pass21", "showStrCB"]),
  },
  watch: {
    nOfRidesSelected() {
      if (
        this.nOfRidesSelected != null &&
        (this.nOP != null || this.dataTrain.nOPa == 1)
      ) {
        this.go4ward = true;
      } else {
        this.go4ward = false;
      }
    },
    nOP() {
      if (this.nOfRidesSelected != null && (this.nOP != null || this.dataTrain.nOPa == 1)) {
        this.go4ward = true;
      } else {
        this.go4ward = false;
      }
    },
  },
  mounted: function () {
    var today = dayjs();
    var travelDateArr = this.$store.state.dataTrain.travelDate.split(".");
    this.nOfRidesSelected = this.$store.state.dataTrain.nOfRides == 1 ? 1 : null;
    var travelDate = dayjs(
      new Date(
        travelDateArr[2],
        parseInt(travelDateArr[1]) - 1,
        travelDateArr[0]
      )
    );
    if (travelDate > today) {
      this.setVar({ pos: "showWarning", val: false });
      this.additionalTrainTile7 =
        this.$store.state.selectedLang.AdditionalTrainTile7a;
    }
  },
  methods: {
    ...mapActions([
      "setSelectedDiv",
      "setVar",
      "goToStep",
      "killRun",
      "backToSpecificTile",
    ]),
    confirmJournes() {
      if (this.$refs.sR1Form.validate()) {
        if (this.nOfRidesSelected == 0) {
          this.$store.state.dataTrain.trCancelDirection = "outward";
        } else if (this.nOfRidesSelected == 1) {
          this.$store.state.dataTrain.trCancelDirection = "return";
        } else if (this.nOfRidesSelected == 2) {
          this.$store.state.dataTrain.trCancelDirection = "both";
        }

        if (this.nOP == null) {
          this.nOP = this.$store.state.dataTrain.nOPa;
        }

        if (this.nOP != 0) {
          if (this.nOP == 1) {
            this.$store.state.rejectionMessage =
              this.selectedLang.AdditionalTrainTile17;
          } else if (this.nOP == 2) {
            this.$store.state.rejectionMessage =
              this.selectedLang.AdditionalTrainTile18;
          }
          this.setSelectedDiv("32");
        } else {
          if (this.showStrCB) {
            this.setSelectedDiv("37");
          } else {
            this.setSelectedDiv("24");
          }
        }
        this.setVar({ pos: "pass21", val: true });
        this.goToStep({ vm: this, val: this.selectedDiv });
        this.$gtag.event("2.6 Alle Zugdaten bestaetigt", {
          event_category: "Rechner",
          event_label: "2.6 Alle Zugdaten bestaetigt",
        });
      }
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
  },
};
</script>
